import React, { useMemo } from "react";
import Form from "react-bootstrap/Form";
import { getCountryOptions } from "../../utils/countryOptions";

/**
 * Renders the "Country Code" half of the phone row.
 *  - permissionGranted === true / null (pending): the original read-only,
 *    auto-filled text field (same look as CollectionInnerAbout).
 *  - permissionGranted === false: a required dropdown the visitor must
 *    pick from, since we have nothing to auto-fill.
 */
function CountryCodeField({
  countryCode,
  onManualSelect,
  onBlur,
  permissionGranted,
}) {
  const options = useMemo(() => getCountryOptions(), []);

  if (permissionGranted === false) {
    return (
      <Form.Select
        className="custom-form-control country-code-select"
        name="countryCode"
        value={countryCode}
        onChange={onManualSelect}
        onBlur={onBlur}
      >
        <option value="">Select Country Code</option>
        {options.map((c) => (
          <option key={c.iso2} value={c.dialCode}>
            {c.name} ({c.dialCode})
          </option>
        ))}
      </Form.Select>
    );
  }

  return (
    <Form.Control
      className="custom-form-control"
      type="text"
      name="countryCode"
      placeholder={countryCode ? `${countryCode} ` : "+XX "}
      value={countryCode}
      onBlur={onBlur}
      readOnly
    />
  );
}

export default CountryCodeField;
